//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { COOKIE_NAME as INTRO_COOKIE_NAME } from '~/components/banner-intro-upsell.vue';
import { COOKIE_NAME as HIFI_COOKIE_NAME } from '~/components/banner-hifi-upsell.vue';
import { COOKIE_NAME as FAMILY_COOKIE_NAME } from '~/components/banner-family-upsell.vue';
import { REMOVE_PERSISTENT_NOTIFICATION, SET_COOKIE_BANNER_HIDDEN } from '~/store/mutationTypes';

const HIDE_COOKIE_OPTIONS = { maxAge: 60 * 60 * 24 * 30 };

export default {
    props: {
        hideMenu: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            /** @type {string[]} */
            hiddenBanners: [],
            dropdownVisible: false,
            closedReverificationMessage: false,
            closedFamilyDowngradeMessage: false,
        };
    },
    computed: {
        COOKIES() {
            return {
                FAMILY_COOKIE_NAME,
                HIFI_COOKIE_NAME,
                INTRO_COOKIE_NAME,
            };
        },
        /** @return {boolean} */
        canShowUpsellBanner() {
            if (this.userInfo) {
                const { isChild, expectedCharge, isOnGracePeriod, isPartnerUser } = this.userInfo;
                return this.getRouteBaseName() === 'profile'
                    && this.isLoggedIn
                    && !isChild
                    && !isOnGracePeriod
                    && !isPartnerUser
                    && expectedCharge.chargeReason !== 'PREPAID';
            }
            return false;
        },
        isLoggedIn() {
            return this.$tidalAuth.isLoggedIn();
        },
        /** @return {boolean} */
        notificationContainerOpen() {
            const subscription = this.userInfo?.subscription || false;
            return subscription && this.getRouteBaseName() !== 'subscription'
                && (
                    (subscription.shouldShowStudentReverificationMessage && !this.closedReverificationMessage) ||
                    (subscription.shouldShowFamilyDowngradeIfNoChildrenMessage && !this.closedFamilyDowngradeMessage)
                );
        },
        /** @return {TIDAL.Internal.PersistentNotification[]} */
        persistentNotifications() {
            return this.$store.state.persistentNotifications;
        },
        /** @return {TIDAL.UserInfo?} */
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    created() {
        if (this.$cookies.get(HIFI_COOKIE_NAME)) {
            this.hiddenBanners.push(HIFI_COOKIE_NAME);
        }
        if (this.$cookies.get(FAMILY_COOKIE_NAME)) {
            this.hiddenBanners.push(FAMILY_COOKIE_NAME);
        }
    },
    mounted() {
        if (this.$tidalAuth.isLoggedIn()) {
            this.$toast.updateDefaults(this.$toastDefaults);
        }
    },
    methods: {
        /** @param {Boolean} visibility */
        dropdownToggled(visibility) {
            this.dropdownVisible = visibility;
        },
        /** @param {string} type Banner type */
        isBannerHidden(type) {
            return this.hiddenBanners.includes(type);
        },
        /** @param {string} type Banner type */
        hideBanner(type) {
            this.hiddenBanners.push(type);
            this.$cookies.set(type, true, HIDE_COOKIE_OPTIONS);
        },
        /** @param {TIDAL.Internal.PersistentNotification['id']} id */
        removeNotification(id) {
            this.$store.commit(REMOVE_PERSISTENT_NOTIFICATION, id);
        },
        onCookieBannerHidden() {
            this.$store.commit(SET_COOKIE_BANNER_HIDDEN);
        },
        /**
         * @param {string} key
         * @return {string} The cookie translation.
         */
        getCookieTranslation(key) {
            return /** @type {string} */ (this.$t(`webCommon.cookie.${key}`));
        },
    },
};
